var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 16.625H7C3.5 16.625 1.75 15.75 1.75 11.375V7C1.75 3.5 3.5 1.75 7 1.75H14C17.5 1.75 19.25 3.5 19.25 7V11.375C19.25 14.875 17.5 16.625 14 16.625H13.5625C13.2913 16.625 13.0288 16.7562 12.8625 16.975L11.55 18.725C10.9725 19.495 10.0275 19.495 9.45 18.725L8.1375 16.975C7.9975 16.7825 7.67375 16.625 7.4375 16.625Z",
    stroke: "#666666",
    strokeWidth: 2.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9971 9.625H14.005",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4971 9.625H10.505",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99519 9.625H7.00305",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultChatIcon);
export default __webpack_public_path__ + "static/media/default-chat-icon.a9c9a499fa649de7f6d8cf607694c096.svg";
export { ForwardRef as ReactComponent };